// Dependencies
import React, { memo, useCallback } from "react";

// Internal dependencies
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { default as TickIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/tick/16";
import { ElementObserver } from "@swiggy-private/core-ui";
import { DELIVERY_SPEED } from "@swiggy-private/cart-types";
import { DELIVERY_SPEED_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { isEmpty } from "@swiggy-private/js-utils";
import { getOptinAriaLabel } from "@cart-ui/components/delivery-options/helpers";

// Widgets
import { CheckboxContainer, DeliverySpeedOptinContainer } from "./DeliverySpeedOptinWidget.style";

interface DeliverySpeedOptinWidgetProps {
    optInText?: string;
    isOptedIn?: boolean;
    selectedSlaOption?: DELIVERY_SPEED;
    onOptInWidgetClick?: (optInValue: boolean) => void;
    onOptInWidgetViewEnter?: () => void;
}

const DeliverySpeedOptinWidget = ({
    optInText,
    isOptedIn,
    selectedSlaOption,
    onOptInWidgetClick,
    onOptInWidgetViewEnter,
}: DeliverySpeedOptinWidgetProps) => {
    const onClick = useCallback(() => {
        onOptInWidgetClick?.(!isOptedIn);
    }, [isOptedIn, onOptInWidgetClick]);

    if (selectedSlaOption !== DELIVERY_SPEED.BATCH_NO_RUSH || isEmpty(optInText)) {
        return null;
    }

    const ariaLabel = getOptinAriaLabel(isOptedIn, optInText);

    return (
        <ElementObserver onViewEnter={onOptInWidgetViewEnter}>
            <DeliverySpeedOptinContainer
                data-testid={DELIVERY_SPEED_WIDGET_TEST_IDS.DELIVERY_SPEED_OPT_IN_WIDGET}
                onClick={onClick}
            >
                <CheckboxContainer aria-hidden="true" isOptedIn={isOptedIn}>
                    {isOptedIn && (
                        <GenericIcon Icon={TickIcon} fillColor="background_Primary" strokeColor="background_Primary" />
                    )}
                </CheckboxContainer>
                <Text variant="V2.body3.neutral.medium" aria-label={ariaLabel} color="text_Med_Emphasis">
                    {optInText}
                </Text>
            </DeliverySpeedOptinContainer>
        </ElementObserver>
    );
};

export default memo(DeliverySpeedOptinWidget);
